// extracted by mini-css-extract-plugin
export default {"container":"Vip_container__RLKRt","wrapper":"Vip_wrapper__F8InG","content":"Vip_content__GH61R"};